export default __webpack_public_path__ + "static/clients02-bd69cae3cd39f3344496b514700df1c6.svg";